import React from 'react';
import styles from '../../../styles/LoginRegister.module.css';

interface Step {
  id: number;
  title: string;
  description: string;
}

interface ProgressStepperProps {
  currentStep: number;
  steps: Step[];
}

const ProgressStepper: React.FC<ProgressStepperProps> = ({ currentStep, steps }) => {
  return (
    <div className={styles.stepper}>
      {steps.map((step, index) => (
        <div key={step.id} className={styles.stepperItem}>
          <div 
            className={`${styles.stepperCircle} ${
              currentStep > index ? styles.completed : 
              currentStep === index ? styles.active : styles.pending
            }`}
          >
            {currentStep > index ? '✓' : step.id}
          </div>
          <div className={styles.stepperContent}>
            <div className={styles.stepperTitle}>{step.title}</div>
            <div className={styles.stepperDescription}>{step.description}</div>
          </div>
          {index < steps.length - 1 && (
            <div 
              className={`${styles.stepperLine} ${
                currentStep > index ? styles.completed : ''
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ProgressStepper;
